import React from 'react'
import { Button } from 'src/components'
import { PageTitle } from 'src/components/PageTitle'
import { Download, Filter } from 'src/assets/svg'
import { more } from 'src/assets/png'
import { useStyles } from './styles'

type DeathsAndDiseasesHeaderProps = {
  isLoading: boolean
  hasData: boolean
  onExport: () => void
  onFilter: () => void
  onCreate: () => void
}

export const DeathsAndDiseasesHeader: React.FC<DeathsAndDiseasesHeaderProps> = ({
  isLoading,
  hasData,
  onExport,
  onFilter,
  onCreate
}) => {
  const styles = useStyles()

  return (
    <div className={styles.propertiesHeader}>
      <PageTitle title='Mortes e Doenças' />

      <div className={styles.buttonContainer}>
        <Button
          className={`${styles.buttonOutlined} ${styles.buttonWrapper}`}
          onClick={onExport}
          disabled={isLoading || !hasData}
          outlined
        >
          <Download className='icon' />
          Exportar
        </Button>

        <Button
          className={`${styles.buttonOutlined} ${styles.buttonWrapper}`}
          onClick={onFilter}
          disabled={isLoading || !hasData}
          outlined
        >
          <Filter className='icon' />
          Filtrar
        </Button>

        <Button className={styles.buttonWrapper} onClick={onCreate}>
          <img src={more} alt='Incluir' />
          Cadastrar Injúria
        </Button>
      </div>
    </div>
  )
}
